import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const alchemy = defineConnector({
  identifier: "alchemy",
  name: "Alchemy",
  tagLine: "Blockchain infrastructure APIs",
  logo,
  protocol: "http",
  tags: ["engineering", "data"],
  defaultUrlPattern: () => "https://[^/]+\\.g\\.alchemy\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an Alchemy API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Alchemy dashboard, create an app and copy its API key. Alchemy supports sending the API key in the `Authorization` header as a bearer token.",
        },
      ],
    },
    {
      title: "Enter your Alchemy API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://eth-mainnet.g.alchemy.com/v2",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        jsonrpc: "2.0",
        id: 1,
        method: "eth_blockNumber",
        params: [],
      }),
    }),
  },
});
